export type AlignH = 'inherit' | 'left' | 'center' | 'right' | 'justify';
export type AlignV = 'top' | 'bottom' | 'center';

export type ButtonSizes = 'small' | 'medium' | 'large';

export type FlexDirection =
  | 'row'
  | 'row-reverse'
  | 'column'
  | 'column-reverse'
  | 'inherit'
  | 'initial'
  | 'revert'
  | 'unset';

export enum CurrencyType {
  CAD = 'C$',
  EUR = '€',
  GBP = '£',
  NZD = 'NZ$',
  ZAR = 'R',
  USD = '$',
}
